module.exports = __webpack_public_path__ + "img/bind-mm-bg.8d5a944e.png";